<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
/**
 * Products component
 */
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      formPro: {
        direccionp: "",
        empleado: "",
        nit_proveedor: "",
        no_factura: "",
        fecha_compra: "",
        tienda: "",
        proveedor: "",
        total: "",
        state: true,
        id: 0,
      },
      detallecompra: [],
      title: "Compras",
      items: [
        {
          text: "Compras",
          href: "/",
        },
        {
          text: "Compras",
          active: true,
        },
      ],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    detalle() {
      axios
        .get(
          process.env.VUE_APP_URL +
            "compras/view_compra?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.detallecompra = response.data.compra.detalle_compras;
          this.formPro.total = response.data.compra.total_c;
          this.formPro.direccionp =
            response.data.compra.proveedore.direccion_proveedor;
          this.formPro.fecha_compra = this.showDate(
            response.data.compra.fecha_compra
          );
          this.formPro.no_factura = response.data.compra.no_factura_c;
          this.formPro.proveedor =
            response.data.compra.proveedore.company_proveedor;
          this.formPro.nit_proveedo =
            response.data.compra.proveedore.nit_proveedor;
          this.formPro.empleado =
            response.data.compra.user.empleado.persona.nombre_persona +
            " " +
            response.data.compra.user.empleado.persona.apellido_persona;

          console.log(response.data.compra);
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-9">
        <div class="row mb-3">
          <div class="col-xl-4 col-sm-6">
            <div class="mt-2">
              <h5>Orden de Compra</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="invoice-title">
              <h4 class="float-end font-size-16">
                Compra# {{ this.formPro.no_factura }}
              </h4>
              <!--   <div class="mb-4">
                <img
                  src="@/assets/images/logo-dark.png"
                  alt="logo"
                  height="20"
                /> 
              </div>-->
            </div>
            <hr />
            <div class="row">
              <div class="col-6">
                <address>
                  <strong>Proveedor:</strong>
                  <br />
                  {{ this.formPro.proveedor }} <br />
                  <strong>NIT:</strong> <br />{{ this.formPro.nit_proveedo }}
                  <br />
                  <strong>Dirección:</strong> <br />
                  {{ this.formPro.direccionp }} <br />
                </address>
              </div>
              <div class="col-6 text-sm-end">
                <address>
                  <strong>Comprador:</strong>
                  <br />Usuario: <br />{{ this.formPro.empleado }}
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3">
                <address>
                  <strong>Empresa:</strong>
                  <br />Zona Auto <br />zonaauto@email.com<br />
                  San Marcos
                </address>
              </div>
              <div class="col-6 mt-3 text-sm-end">
                <address>
                  <strong>Fecha de Compra:</strong>
                  <br />{{ this.formPro.fecha_compra }}
                  <br />
                  <br />
                </address>
              </div>
            </div>
            <div class="p-2 mt-3">
              <h3 class="font-size-16">Resumen de Orden</h3>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 70px">No.</th>
                    <th>Producto</th>
                    <th>Cantidad</th>
                    <th>Precio</th>
                    <th class="text-sm-end">Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, idx) in this.detallecompra"
                    v-bind:key="idx"
                  >
                    <td class="text-center">{{ idx + 1 }}</td>
                    <td>
                      {{ item.stock.producto.nombre_producto }}
                      {{ item.stock.presentacione.nombre_presentacion }}
                    </td>
                    <td class="text-sm-end">{{ item.cantidad_compra }}</td>
                    <td class="text-sm-end">
                      {{ money(item.stock.precio_compra_stock) }}
                    </td>
                    <td class="text-sm-end">
                      {{ money(item.subtotal_compra) }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4" class="border-0 text-sm-end">
                      <strong>Total</strong>
                    </td>
                    <td class="border-0 text-sm-end">
                      <h4 class="m-0">{{ money(this.formPro.total) }}</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <router-link
                  :to="{
                    name: 'compras',
                  }"
                  class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Regresar
                </router-link>
              </div>
              <!-- end col -->

              <!-- end col -->
            </div>
            <div class="d-print-none">
              <div class="float-end">
                <a
                  href="javascript:window.print()"
                  class="btn btn-primary w-md waves-effect waves-light me-1"
                  ><i class="fa fa-print"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
table td {
    font-size: small;
  }
  table tr {
    margin-bottom: 5px; /* Puedes ajustar el valor según tus preferencias */
  }</style>
